import classNames from "classnames";
import { useContext } from "react";
import { useParams } from "react-router";
import { ClipLoader } from "react-spinners";
import { common_utils } from "../../../../../../../common/common_utils";
import { Constants } from "../../../../../../../common/constants";
import {
	SyncDirection,
	syncDirectionToName,
} from "../../../../../../../common/sesh_types";
import { sync_utils } from "../../../../../../../common/sync_utils";
import { SyncEntity } from "../../../../../../../src/entity/Sync";
import { ErrorNote } from "../../../../forms/improved_components/error_note";
import { SelectableBox } from "../../../../forms/improved_components/selectable_box";
import { trpc } from "../../../../utils/trpc";
import { GuildSettingsContext } from "../../../guild_settings";
import SyncTypeTag from "./sync_type_tag";

export default function SyncTypeBox(props: {
	syncType: SyncDirection;
	onSelect: () => void;
}) {
	const name = syncDirectionToName(props.syncType);
	const description = syncTypeToDescription(props.syncType);

	const { server_id } = useParams<{ server_id: string }>();

	const getSyncsOrAuthURLQuery = trpc.gcal.getSyncsOrAuthURL.useQuery(
		{
			guild_id: server_id,
		},
		{ staleTime: 1000 * 60 * 60 * 24 }
	);

	const { is_premium } = useContext(GuildSettingsContext);

	let icon: JSX.Element;
	let disabled = false;
	if (getSyncsOrAuthURLQuery.isSuccess) {
		if (!getSyncsOrAuthURLQuery.data.isLoggedIn) {
			disabled = true;
			return <ErrorNote error={"Not logged in"} />;
		}

		if (
			sync_utils.isSyncLimitReached(
				getSyncsOrAuthURLQuery.data.syncs,
				props.syncType,
				is_premium
			)
		) {
			disabled = true;

			if (is_premium) {
				icon = (
					<>
						<i className="fas fa-lock"></i> Limit reached
					</>
				);
			} else {
				icon = (
					<p className="text-right">
						<i className="fas fa-lock"></i> Free Limit reached
						<br />
						<span className="text-right">
							Get{" "}
							<a
								href={common_utils.getGuildSettingsURL(
									server_id,
									"premium"
								)}
								className="manual-link"
							>
								Premium
							</a>
						</span>
					</p>
				);
			}
		} else {
			icon = <i className="fas fa-chevron-right "></i>;
		}
	} else {
		disabled = true;
		icon = <ClipLoader />;
	}

	return (
		<SelectableBox
			onClick={props.onSelect}
			disabled={disabled}
			bgColor="semidark"
		>
			<div className="flex flex-col text-content-primary-darker">
				<div className="flex gap-1">
					<p className="has-text-weight-bold white-text">{name}</p>
					<SyncTypeTag syncType={props.syncType} />
				</div>
				{description}
			</div>
			<div className="ml-auto self-center text-content-primary">
				{icon}
			</div>
		</SelectableBox>
	);
}

function syncTypeToDescription(syncType: SyncDirection) {
	switch (syncType) {
		case SyncDirection.Outbound:
			return <p>Export events to Google Calendar in realtime</p>;
		case SyncDirection.Inbound:
			return (
				<div>
					<p>Import events from Google Calendar in realtime</p>
				</div>
			);
		case SyncDirection.Bidirectional:
			return (
				<div>
					<p>Sync in both directions in realtime</p>
				</div>
			);
	}
}
